<ng-container *transloco="let t;">

  <p-card>
    <app-reporting-table
      [type]="'toolbox'"
    ></app-reporting-table>
  </p-card>

</ng-container>
